import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

// Read-only visibility for beta-tester / custom fee overrides that have reached their review
// date. The override keeps applying at its current rate (it is NEVER silently reverted) — this
// only surfaces the accounts an admin should now decide on (adjust rate / extend / clear) from
// the account drawer. Backed by GET /api/admin/fee-overrides/review.
export function BetaOverridesNeedingReview({ onOpen }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/fee-overrides/review")
      .then(({ data }) => setRows(data?.accounts || []))
      .catch(() => setRows([]));
  }, []);

  if (!rows || rows.length === 0) return null;

  return (
    <div className="pt-1" data-testid="beta-overrides-review">
      <div className="inline-flex flex-col gap-1 border border-volt/30 bg-volt/5 px-3 py-2 max-w-xl">
        <div className="flex items-center gap-1.5 font-mono uppercase text-[10px] tracking-wide text-volt">
          <AlertTriangle className="w-3.5 h-3.5" /> Fee overrides needing review ({rows.length})
        </div>
        <span className="font-mono text-[10px] text-muted-foreground normal-case">
          Past their review date — still applying at the current rate. Click to adjust / extend / clear.
        </span>
        <div className="flex flex-wrap gap-1" data-testid="beta-overrides-review-list">
          {rows.map((u) => {
            const fo = u.fee_override || {};
            return (
              <button key={u.user_id} data-testid={`beta-override-review-${u.username}`}
                onClick={() => onOpen && onOpen(u.user_id)}
                title={`${u.email || ""} · ${Number(fo.rate ?? 0)}% · ${fo.source || "custom"}`}
                className="font-mono text-[10px] px-1.5 py-0.5 border border-volt/30 text-volt/90 normal-case hover:bg-volt/10 transition-colors">
                @{u.username} · {Number(fo.rate ?? 0)}%
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
